module.exports = __webpack_public_path__ + "static/media/transfer.c61bc002.svg";